export const iconFontAwesomeWritingKeyboard = (
	<i className="fa-solid fa-keyboard"></i>
);
